import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FooterLink } from '../../styled-components.js'

/**
 * Component to display version information
 * Follows Single Responsibility Principle by isolating version display logic
 */
const VersionInfo = () => {
  const versionName = import.meta.env.VITE_VERSION_NAME || 'Tool'
  const versionNumber = import.meta.env.VITE_REACT_APP_VERSION || '00'
  const targetEnv = import.meta.env.VITE_TARGET_ENV
  const isProduction = !targetEnv || targetEnv === 'production'

  return (
    <FooterLink style={{ gap: '0.25rem' }}>
      <FormattedMessage id={'help_view_app_version_title'} />
      <span>{versionName}</span>
      <span>
        <span>{versionNumber}</span>
        {!isProduction && <span>{targetEnv.substring(0, 2)}</span>}
      </span>
    </FooterLink>
  )
}

export default VersionInfo
